import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const guarantees = ['Immediate access', '14-day guarantee', '100% secure payment', 'No subscriptions or hidden charges'];
export function UrgencyClose() {
  return <section id="urgency-close" className="bg-forest-green py-12 md:py-16 px-4 sm:px-6 lg:px-8 text-white" data-id="element-250">
      <div className="max-w-3xl mx-auto text-center" data-id="element-251">
        <FadeIn data-id="element-252">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gold mb-10" data-id="element-253">
            One Last Thing Before You Go:
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg md:text-xl text-gray-200 leading-relaxed mb-12" data-id="element-254">
          <FadeIn delay={0.1} data-id="element-255">
            <p data-id="element-256">
              Every morning you wait is another morning of stiffness. Another
              morning of cracking joints. Another day feeding the silent fire.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-257">
            <p data-id="element-258">
              The protocol in front of you costs less than a coffee at
              Starbucks. The ingredients are available at any grocery store. The
              longest preparations take 20 minutes.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-259">
            <p className="font-bold text-white" data-id="element-260">
              There is no logical reason not to try it.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-261">
            <p className="font-serif italic text-2xl text-gold py-4" data-id="element-262">
              The only real question is: How many more mornings are you going to
              wait?
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-263">
          <a href="https://vitalyforms.com/cart/48958975508700:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-gold hover:bg-yellow-500 text-forest-green text-xl md:text-2xl font-bold py-6 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl mb-10" data-id="element-264">
            👆 YES, I WANT TO DOWNLOAD "THE SILENT FIRE" FOR $7
          </a>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-265">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-medium text-gray-300" data-id="element-266">
            {guarantees.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-267">
                <CheckCircle2 className="w-5 h-5 text-sage-light" data-id="element-268" />
                <span data-id="element-269">{item}</span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}